import React from "react";
import { Helmet } from "react-helmet";
import { ShoppingCart, LayoutTemplate, ShieldCheck, Server, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import SEO from '../../components/SEO';


const EcommerceWebsiteDevelopment = () => {
  return (
      <>
    <SEO title="ECommerce Website Development" />
    <div className="w-full max-w-7xl mx-auto px-4 py-12">
      <Helmet>
        <title>eCommerce Website Development | AKHSoft</title>
        <meta
          name="description"
          content="Boost your sales with custom eCommerce website development services by AKHSoft. We create secure, mobile-friendly, and scalable online stores that convert."
        />
      </Helmet>

      {/* Header */}
      <section className="mb-12">
        <h1 className="text-4xl font-bold text-[#ff9b00] mb-4">eCommerce Website Development</h1>
        <p className="text-gray-700 text-lg max-w-3xl">
          Ready to launch or upgrade your online store? AKHSoft delivers high-performing eCommerce websites that are fast, mobile-ready, and conversion-focused.
        </p>
      </section>

      {/* Features */}
      <section className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-12">
        <FeatureCard
          icon={<ShoppingCart size={40} className="text-[#ff9b00]" />}
          title="Custom Storefront Design"
          description="Your store's design reflects your brand. We create unique, modern, and engaging designs for optimal user experience and higher sales."
        />
        <FeatureCard
          icon={<LayoutTemplate size={40} className="text-[#ff9b00]" />}
          title="Mobile-Responsive Layout"
          description="More than 60% of eCommerce happens on mobile. Our designs are 100% responsive across all devices."
        />
        <FeatureCard
          icon={<Server size={40} className="text-[#ff9b00]" />}
          title="Easy Inventory Management"
          description="Control your product stock, categories, and variants in real-time with an intuitive dashboard customized for your business."
        />
        <FeatureCard
          icon={<ShieldCheck size={40} className="text-[#ff9b00]" />}
          title="Secure Payment Integration"
          description="We integrate trusted payment gateways and secure checkout to build customer trust and ensure smooth transactions."
        />
      </section>

      {/* Why Choose Us */}
      <section className="bg-orange-50 rounded-xl p-6 mb-12">
        <h2 className="text-2xl font-bold text-[#ff9b00] mb-4">Why Choose AKHSoft?</h2>
        <ul className="list-disc list-inside text-gray-700 space-y-2 text-base">
          <li>Custom eCommerce development tailored to your business goals.</li>
          <li>Platform expertise: Shopify, WooCommerce, Magento, Headless CMS.</li>
          <li>SEO-friendly, fast-loading, and scalable code architecture.</li>
          <li>Post-launch support with maintenance, analytics, and training.</li>
        </ul>
      </section>

      {/* CTA */}
      <section className="text-center mt-16">
        <h3 className="text-3xl font-bold text-gray-800 mb-4">Start Selling Online Today</h3>
        <p className="text-gray-600 mb-6 max-w-xl mx-auto">
          Let’s build your online store the right way — professional, powerful, and ready to scale.
        </p>
        <Link
          to="/contact-us"
          className="inline-flex items-center bg-[#ff9b00] text-white font-semibold px-6 py-3 rounded-full hover:bg-orange-600 transition"
        >
          Contact Us
          <ArrowRight className="ml-2" size={18} />
        </Link>
      </section>
    </div>
    </>
  );
};

// Reusable FeatureCard Component
const FeatureCard = ({ icon, title, description }) => (
  <div className="flex items-start gap-4">
    <div className="flex-shrink-0">{icon}</div>
    <div>
      <h4 className="text-xl font-semibold text-gray-800">{title}</h4>
      <p className="text-gray-600">{description}</p>
    </div>
  </div>
);

export default EcommerceWebsiteDevelopment;
